import React from 'react';
import { PROMO_TICKER } from '../data/catalog';
import './PromoBar.css';

export default function PromoBar() {
  const items = [...PROMO_TICKER, ...PROMO_TICKER]; // duplicate for seamless loop
  return (
    <div className="nx-promobar" role="region" aria-label="Promotions">
      <div className="nx-promobar__track">
        {items.map((msg, i) => (
          <span className="nx-promobar__item" key={i}>
            {msg}
          </span>
        ))}
      </div>
    </div>
  );
}
